<div class="progresStepper" data-tour="caso.estados">
  <mat-horizontal-stepper
    labelPosition="bottom"
    [selectedIndex]="statusNumber"
    #stepper
    class="stepper"
  >
    <mat-step #sinAsignar [completed]="false">
      <ng-template matStepLabel>Sin asignar</ng-template>
    </mat-step>
    <mat-step [completed]="false">
      <ng-template matStepLabel>Asignado</ng-template>
    </mat-step>
    <mat-step [completed]="false">
      <ng-template matStepLabel>En proceso</ng-template>
    </mat-step>
    <mat-step [completed]="false">
      <ng-template matStepLabel>Por aprobar</ng-template>
    </mat-step>
    <!-- <mat-step [completed]="false" >
      <ng-template matStepLabel>Rechazado</ng-template>
    </mat-step> -->
    <mat-step [completed]="false">
      <ng-template matStepLabel>Finalizado</ng-template>
    </mat-step>
  </mat-horizontal-stepper>
  <div class="divTrigger">
    <mat-icon
      class="buttonMenu"
      data-tour="caso.menu"
      [matMenuTriggerFor]="menu"
      *ngIf="!isLoading; else spinner"
    >
      more_horiz
    </mat-icon>

    <ng-template #spinner>
      <mat-progress-spinner
        mode="indeterminate"
        diameter="24"
        strokeWidth="4"
        class="spinner"
      >
      </mat-progress-spinner>
    </ng-template>
  </div>
  <mat-menu #menu="matMenu">
    <ng-container *ngIf="needApproval && assignedApproval">
      <button mat-menu-item (click)="approval()">Aprobar</button>
      <button mat-menu-item (click)="reject()">Devolver</button>
    </ng-container>
    <button *ngIf="canAssign" mat-menu-item (click)="assign()">Asignar</button>
    <button *ngIf="cantipifi && isNot3" mat-menu-item (click)="tipificar()">
      <span>Tipificar</span>
    </button>
    <button
      disabled
      mat-menu-item
      (click)="edit(case._id)"
      *ngIf="
        canEdit && (case?.status != 'toFinalize' || case?.status != 'finalized')
      "
    >
      <span>Editar</span>
    </button>
    <button mat-menu-item (click)="openRecord()">
      <span>Ver historial</span>
    </button>
    <!-- Botones para generar PDF -->
    <!-- <button
      *ngIf="
        (case?.status === 'toFinalize' || case?.status != 'finalized') &&
        hasCreateCasesPermission &&
        isNot3
      "
      mat-menu-item
      (click)="generatePDF()"
    >
      Descargar Reporte de Alerta
    </button> -->
    <!-- Input para cargar la imagen -->
    <button
      *ngIf="
        case?.status === 'toFinalize' && hasCreateCasesPermission && isNot3
      "
      mat-menu-item
      (click)="generatePDFPreviewPage()"
      [disabled]="!case"
    >
      Previsualizar Reporte de Alerta
    </button>
    <!-- <button mat-button (click)="logCaseProperties()">Log Case Properties</button> -->
  </mat-menu>
</div>
